/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { AuthAccessTokenDetails, OauthAEMConfig } from '../../models';
import { LoginRememberMeUtilsService } from '../login-remember-me/login-remember-me-utils-service/login-remember-me-utils.service';
import { LoginRememberMeWrapperService } from '../login-remember-me/login-remember-me-wrapper-service/login-remember-me-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class AppTokenHelperService {
  protected loginRememberMeWrapper = inject(LoginRememberMeWrapperService);
  protected loginRememberMeUtils = inject(LoginRememberMeUtilsService);
  protected logging = inject(LoggingService);

  tokenMap: Map<string, AuthAccessTokenDetails> = new Map();

  sendHeaderTokenServiceWorker(
    config: OauthAEMConfig,
    tokenResponse: AuthAccessTokenDetails
  ): void {
    if (
      config?.ENABLE_NEW_PERSISTENT_LOGIN &&
      this.loginRememberMeUtils.checkServiceWorkerController() &&
      config.CLIENT_ID_VALUE === config.HEADER_CLIENT_ID_VALUE
    ) {
      this.loginRememberMeUtils.sendMessage({
        type: 'ADD_HEADER_TOKEN',
        headerToken: tokenResponse?.access_token,
        headerIssueTime: tokenResponse?.token_issued_time,
        headerExpiresIn: tokenResponse?.expires_in
      });
    }
  }

  async isHeaderTokenAvailable(): Promise<AuthAccessTokenDetails> {
    if (this.loginRememberMeUtils.checkServiceWorkerController()) {
      return await this.loginRememberMeUtils
        .sendMessage({ type: 'GET_HEADER_TOKEN' })
        .then(async (data: any) => {
          if (
            data?.headerToken &&
            data?.headerIssueTime &&
            data?.headerExpiresIn
          ) {
            return {
              access_token: data?.headerToken,
              token_issued_time: data?.headerIssueTime,
              expires_in: data?.headerExpiresIn
            } as AuthAccessTokenDetails;
          } else {
            return {} as AuthAccessTokenDetails;
          }
        })
        .catch(() => {
          return {} as AuthAccessTokenDetails;
        });
    } else {
      return {} as AuthAccessTokenDetails;
    }
  }
}
